import React, { useRef, useState } from 'react';
import styles from './form.module.css';
import PrivacyPolicy from '../privacy/privacy';


const ContactForm = () => {
  // State for form submission status
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  // Refs for form fields
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);

  // Server settings
  const serverUrl = "https://dynamic-server-dfc88e1f1c54.herokuapp.com/leads/newLead";
  const reciver = "Kerenaxelrod@gmail.com";
  const webhookUrl = "https://hook.us1.make.com/btghlzqtwm5c0hw1xali1h2h973ii1pd";

  const sendToWebhook = async (data) => {
    try {
      const response = await fetch(webhookUrl, {
        method: "POST",
        body: new URLSearchParams(data),
      });
      console.log("Webhook sent successfully", response.status);
    } catch (err) {
      console.error("Webhook error:", err);
    }
  };

  const handleTermsClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPrivacyModalOpen(true);
  };

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPrivacyModalOpen(true);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const name = nameRef.current.value;
    const email = emailRef.current.value;
    const phone = phoneRef.current.value;

    setIsSubmitting(true);

    // Server data object
    const serverData = {
      name: name,
      phone: phone,
      email: email,
      reason: "קורסים",
      reciver: reciver
    };

    const webhookData = {
      name,
      phone,
      email,
      source: "hamisrad.co.il/קורס-ב",
      timestamp: new Date().toISOString(),
    };

    sendToWebhook(webhookData);

    try {
      // Send to server
      const serverResponse = await fetch(serverUrl, {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(serverData)
      });

      if (serverResponse.ok) {
        setIsSubmitting(false);
        setSubmitted(true);
        
        // הפעלת פיקסל Lead
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Lead');
        }
        
        // Reset form after successful submission
        setTimeout(() => {
          nameRef.current.value = "";
          emailRef.current.value = "";
          phoneRef.current.value = "";
          setSubmitted(false);
        }, 3000);
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      alert("התרחשה שגיאה, אנא נסו שוב מאוחר יותר");
      console.error('Error submitting form:', error);
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.formContainer} id="טופס">
      <h2 className={styles.title}>לשריון שיחת התאמה לתוכנית</h2>
      <p className={styles.subtitle}>מלאי את הטופס ואחזור אלייך בהקדם</p>
      <form className={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="שם מלא"
          ref={nameRef}
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder="נייד"
          className={styles.phoneInput}
          ref={phoneRef}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="אימייל"
          ref={emailRef}
          required
        />

        {isPrivacyModalOpen && (
          <PrivacyPolicy
            ownerName="קרן אקסלרוד - המשרד"
            email="Kerenaxelrod@gmail.com"
            phone="+972 50-891-9747"
            domain="https://hamisrad.co.il/"
            isOpen={isPrivacyModalOpen}
            onClose={() => setIsPrivacyModalOpen(false)}
            showButton={false}
          />
        )}

        <button type="submit" className={styles.submitButton} disabled={isSubmitting || submitted}>
          {isSubmitting ? 'שולח...' : submitted ? 'נשלח בהצלחה!' : 'כן, אני רוצה שתחזרי אליי!'}
        </button>

        {/* תיבת האישור למדיניות הפרטיות */}
        <div className={styles.termsText}>
          בהשארת פרטים אני מאשר/ת כי קראתי והסכמתי ל
          <button 
            type="button"
            className={styles.termsLink}
            onClick={handleTermsClick}
          >
            תנאי שימוש
          </button>
          {" "}ול
          <button 
            type="button"
            className={styles.termsLink}
            onClick={handlePrivacyClick}
          >
            מדיניות הפרטיות
          </button>
          .
        </div>
      </form>

      {/* תמונה מטושטשת מתחת לכפתור */}
      <div className={styles.imageWrapper}>
      
      </div>
    </div>
  );
};

export default ContactForm;